<template>
  <div class="loginPage">
    <div class="content">
      <div class="smallContent">
        <div class="logo">
          <img src="../assets/login/hylogo.png" />
          <p>考生服务系统</p>
        </div>
        <!-- 登录框 -->
        <div class="loginCon" v-show="!changePswF">
          <el-input
            :style="{ margin: '10px 0px 0px ' }"
            :placeholder="language ? '请输入邮箱号' : 'Usercard'"
            v-model="usercard"
            clearable
          ></el-input>
          <el-row class="speace">
            <el-col :span="18">
              <el-input
                class="speace"
                :placeholder="language ? '请输入密码' : 'Password'"
                v-model="password"
                show-password
                clearable
              ></el-input>
            </el-col>
            <el-col :span="6">
              <el-button :style="{ margin: '20px 0px' }" size="mini" type="text" @click="changePswF=true"
                >忘记密码？</el-button
              >
            </el-col>
          </el-row>

          <el-row class="speace">
            <el-col :span="14">
              <el-input
                :placeholder="
                  language ? '验证码(区分大小写)' : 'Type the text you see'
                "
                v-model="valcode"
                clearable
              ></el-input>
            </el-col>
            <el-col :span="10">
              <img id="valimage" :src="valimagesrc" @click="getvalimage" />
            </el-col>
          </el-row>
          <el-button
            class="speace loginBtn"
            type="primary"
            :loading="loading"
            @click="login()"
            >登 录</el-button
          >
        </div>
        <!-- 重置密码 -->
        <div class="loginCon" v-show="changePswF">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-position="left"
            label-width="90px"
            class="demo-ruleForm"
          >
            <el-form-item label="邮箱" prop="mail">
              <el-input v-model="ruleForm.mail" autocomplete="off"></el-input>
            </el-form-item>
            <div class="mailNum">
              <span @click="getMailCode">发送验证码</span>
              <el-input
                v-model="ruleForm.mailNum"
                autocomplete="off"
                placeholder="邮箱验证码"
              ></el-input>
            </div>
            <el-form-item label="新密码" prop="pass">
              <el-input
                type="password"
                v-model="ruleForm.pass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="checkPass">
              <el-input
                type="password"
                v-model="ruleForm.checkPass"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                class="speace loginBtn"
                type="primary"
                :loading="loading"
                @click="changePassword()"
                >修改密码</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <img class="cloudR" src="../assets/login/cloudR.png" />
      <img class="cloudL" src="../assets/login/cloudL.png" />
      <div class="register" @click="changeRegister()">
        <p>{{ registerFlag ? "已有账号，点击登录" : "没有账号？点击注册" }}</p>
        <!-- <p>{{
          language
            ? "没有账号？点击注册"
            : "Don't have an account?Create account"
        }}
               </p> -->
      </div>
      <!-- <div class="changelanguage">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          {{ language ? "中文" : "English"
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="C">中文</el-dropdown-item>
          <el-dropdown-item command="E">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->
      <div class="footer">V1.1</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
      var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      usercard: "",
      password: "",
      valcode: "",
      loading: false,
      language: true,
      registerFlag: false,
      registerMsg: {
        usercard: "",
        username: "",
        password: "",
        repassword: "",
        phone: "",
      },
      valimagesrc: "",
      valimgNum: "",
      ruleForm: {
        pass: "",
        checkPass: "",
        mail: "",
        mailNum: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        mail: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      changePswF:false
    };
  },
  methods: {
    handleCommand(command) {
      if (command == "C") {
        this.language = true;
      } else if (command == "E") {
        this.language = false;
      }
    },
    // 登录
    login() {
      this.loading = true;
      if (this.usercard && this.password && this.valcode) {
        this.$http({
          method: "post",
          url: `/RegistrationMagt/api/v1/Login`,
          data: {
            uid: this.usercard,
            pwd: this.password,
            sCheckCode: this.valcode,
          },
        })
          .then((res) => {
            console.log(res);
            if (res.data.msg == "success") {
              // 保存token
              sessionStorage.setItem(
                "token",
                res.data.response.accessToken.tokenContent
              );
              // 保存用户信息
              console.log(this.$store.state.userInfo);
              this.$store.state.userInfo.id = res.data.response.userInfo.id;
              this.$store.state.userInfo.name = res.data.response.userInfo.name;
              this.$router.push("/index");
            } else {
              this.$message.error(res.data.msg);
              this.getvalimage()
            }
            this.loading = false;
          })
          .catch((_) => {});
      } else {
        this.loading = false;
        this.$allMethods.returnRrror("error", "账号/密码/验证码不能为空");
      }
    },
    // 前往注册页面
    changeRegister() {
      //   console.log(11);
      //   this.registerFlag = !this.registerFlag;
      this.$router.push("/register");
    },
    // 获取验证码
    getvalimage() {
      this.$http({
        method: "post",
        url: `/RegistrationMagt/api/v1/getCheckcode`,
        responseType: "blob",
      }).then((res) => {
        let blob = new Blob([res.data], {
          type: "image/png",
        });
        let url = window.URL.createObjectURL(blob);
        // 将图片转换成img标签可以识别的url
        this.valimagesrc = url;
        // this.valimgNum =windows.cookie('sCheckCode')
      });
    },
    // 修改密码
    changePassword() {
      if(this.ruleForm.mail == ""){
        this.$message.error("请输入邮箱地址");
        return false;
      }  
      if(this.ruleForm.pass == ""){
        this.$message.error("请输入密码");
        return false;
      }
      if(this.ruleForm.checkPass == ""){
        this.$message.error("请再次输入密码");
        return false;
      }
      this.$http({
        method: "post",
        url: `/RegistrationMagt/api/Register/Register`,
        params: {
          mail: this.ruleForm.mail,
          password: this.ruleForm.pass,
          type: 2,
          vcode: this.ruleForm.mailNum,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data.msg == "error") {
            this.$message.error(res.data.response);
          } else if (res.data.msg == "success") {
            this.$allMethods.returnSuccess(res.data.msg, "修改密码", "请重新登录");
            this.$refs.ruleForm.resetFields();
            setTimeout(() => {
              this.$router.go(0);
            }, 1000);
            
          }
        })
        .catch((_) => {});
    },
        // 获取邮箱验证码
    getMailCode() {
      let mail = this.ruleForm.mail;
      //   http://10.168.1.113:5000/
      this.$http({
        method: "post",
        url: `/RegistrationMagt/api/Register/Sendmail`,
        params: {
          Address: mail,
          type: 0,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data.msg == "success") {
            this.$message.success("验证码已发送,请注意查收");
          }
        })
        .catch((_) => {});
    },
  },
  mounted() {
    this.getvalimage();
    // sessionStorage.clear()
  },
  created() {
    var _self = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;

      // if(key == 13 || key == 100){
      if (key == 13) {
        _self.login();
      }
    };
  },
};
</script>
<style scoped>
.loginPage {
  overflow: auto;
  height: 100vh;
  min-width: 826px;
  background: linear-gradient(
    -0.43000000000001deg,
    rgba(212, 228, 252, 1) 0%,
    rgba(218, 232, 252, 1) 2.87%,
    rgba(235, 242, 254, 1) 13.85%,
    rgba(246, 250, 254, 1) 27.53%,
    rgba(253, 254, 255, 1) 46.72%,
    rgba(255, 255, 255, 1) 100%
  );
}
.content {
  height: 590px;
  width: 800px;
  /* box-shadow: 0px 7px 10px rgba(182, 196, 250, 0.75); */
  margin: 120px auto 0px;
  z-index: 1;
  background: url("../assets/login/bottomIMG2.png") no-repeat bottom;
  background-size: 100% auto;
}
.smallContent {
  height: 560px;
  width: 800px;
  box-shadow: 0px 7px 10px rgba(182, 196, 250, 0.75);
  margin: 120px auto 0px;
  padding: 20px;
  z-index: 2;
  padding: 20px;
}
.logo {
  height: 60px;
}
.logo img {
  display: inline-block;
  height: 60px;
}
.logo p {
  display: inline-block;
  position: relative;
  left: 40px;
  top: -20px;
  font-size: 26px;
  font-weight: 700;
}
.loginCon {
  width: 40%;
  margin: 30px auto 10px;
  height: 300px;
  z-index: 3;
}
.registerCon {
  width: 80%;
  margin: 30px auto 10px;
  height: 320px;
  z-index: 3;
  position: relative;
  top: 0px;
}
.registerConForm {
  text-align: left;
}
.register {
  color: #2d76f9;
  font-size: 12px;
  height: 24px;
  z-index: 2;
  position: relative;
  bottom: 150px;
}
.register:hover {
  text-decoration: underline;
  cursor: pointer;
}
.speace {
  margin: 15px 0px;
}
.speace2 {
  margin: 0px 0px;
}
.loginBtn {
  width: 100%;
  margin: 12px 0px !important;
  background-color: #2d76f9 !important;
  border-color: #2d76f9 !important;
  font-size: 14px !important;
  border-radius: 12px;
}
.bottomIMG {
  position: absolute;
  height: 200px;
  width: 900px;
  margin: auto;
  bottom: 250px;
  z-index: 1;
  /* background: url("../assets/login/bottomIMG2.png") no-repeat top; */
  background-size: 100% auto;
}
.bottomIMG img {
  z-index: 1;
  width: 980px;
  position: relative;
  left: -100px;
}
.footer {
  background: #2d76f9;
  height: 30px;
  width: 100%;
  min-width: 1200px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  color: #0095ff;
  text-align: left;
}
.changelanguage {
  position: fixed;
  top: 30px;
  right: 50px;
  cursor: pointer;
}
.cloudR {
  position: relative;
  left: 500px;
  top: -520px;
}
.cloudL {
  position: relative;
  left: -700px;
  top: -300px;
}
.mailNum {
  margin: 20px 0px;
  text-align: right;
}
.mailNum span {
  color: #2d76f9;
  font-size: 12px;
  cursor: pointer;
}
</style>
<style>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.registerCon > .el-input {
  width: 40%;
}
.mailNum > .el-input {
  display: inline-block;
  width: 140px !important;
  margin-left: 40px;
}
</style>